<template>
    <div id="system-early-warning" style="width: 360px;height:220px;"></div>
</template>

<script>
  import {
    UserStore
  } from '@/utils/Mixin'
  const echarts = require('echarts')
  export default {
    mixins: [UserStore],
    data () {
      return {
        list: []
      }
    },
    watch: {
      Data (n) {
        this.getData()
      },
      list () {
        this.init()
      }
    },
    methods: {
      getData () {
        let list = []
        if (this.Data && this.Data.data4 && this.Data.data4.items3) {
          list = this.Data.data4.items3
        }
        this.list = list
      },
      init () {
        // 基于准备好的dom，初始化echarts实例
        var myChart = echarts.init(document.getElementById('system-early-warning'))

        let xAxisData = []
        let seriesData = []

        this.list.forEach((i, k) => {
          xAxisData.push(i.x || '')
          seriesData.push(i.y || 0)
        })

        // 指定图表的配置项和数据
        let option = {
          title: {
            subtext: '单位：次',
            subtextStyle: {
              // 文字颜色
              color: '#74a0bf',
              // 字体大小
              fontSize: 12
            }
          },
          tooltip: {
            show: true,
            trigger: 'axis',
            axisPointer: {
              type: 'cross',
              label: {
                backgroundColor: '#01b3e4'
              }
            }
          },
          dataZoom: [ // 给x轴设置滚动条
            {
              start: 0, // 默认为0
              end: 100 - 1500 / 31, // 默认为100
              type: 'slider',
              // 显示滚动条
              show: false,
              xAxisIndex: [0],
              handleSize: 0, // 滑动条的 左右2个滑动条的大小
              height: 4, // 组件高度
              left: '10%', // 左边的距离
              right: '10%', // 右边的距离
              bottom: 18, // 右边的距离
              borderColor: '#000',
              fillerColor: '#01b3e4',
              borderRadius: 5,
              backgroundColor: '#33384b', // 两边未选中的滑动条区域的颜色
              showDataShadow: false, // 是否显示数据阴影 默认auto
              showDetail: false, // 即拖拽时候是否显示详细数值信息 默认true
              realtime: true, // 是否实时更新
              filterMode: 'filter'
            },
            // 下面这个属性是里面拖到
            {
              type: 'inside',
              show: true,
              xAxisIndex: [0],
              start: 0, // 默认为1
              end: 100 - 1500 / 31 // 默认为100
            }
          ],
          xAxis: {
            type: 'category',
            boundaryGap: true,
            data: xAxisData,
            // 刻度
            axisTick: {
              show: false
            },
            axisLine: {
              lineStyle: {
                type: 'solid',
                color: '#74a0bf', // 左边线的颜色
                width: '1' // 坐标线的宽度
              }
            },
            axisLabel: {
              textStyle: {
                // 坐标值得具体的颜色
                color: '#74a0bf',
                fontSize: 12
              }
            }
          },
          yAxis: {
            type: 'value',
            scale: false, // 自适应
            minInterval: 100, // 分割刻度
            // 坐标轴的分割段数
            splitNumber: 3,
            max: function (value) { // 取最大值向上取整为最大刻度
              return Math.ceil(value.max + 100)
            },
            axisLine: {
              lineStyle: {
                type: 'solid',
                color: '#74a0bf',
                width: '1'
              }
            },
            axisLabel: {
              textStyle: {
                color: '#74a0bf',
                fontSize: 12
              }
            },
            splitLine: {
              show: true, // X网格线
              lineStyle: { // x网格线
                color: '#002d37'
              }
            }
          },
          series: [{
            data: seriesData,
            type: 'bar',
            barWidth: 8, // 柱子的宽度
            showBackground: true,
            backgroundStyle: {
              color: 'rgba(27, 31, 41,1)'
            },
            itemStyle: {
              normal: {
                // 圆角
                barBorderRadius: [4, 4, 0, 0],
                // 背景渐变
                color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                  offset: 0,
                  color: '#eb9c57' // 0% 处的颜色
                }, {
                  offset: 1,
                  color: '#ef4960' // 100% 处的颜色
                }], false)
              }
            }
          }]
        }

        // 使用刚指定的配置项和数据显示图表。
        myChart.setOption(option)
      }
    }
  }
</script>

<style lang="less">
    #system-early-warning {
        box-sizing: border-box;
        margin: 0 auto;
    }
</style>
